export default {
  theEmailIsNecessaryToSendYouTheTicketOrInvoices:
    "L'e-mail è necessaria per inviarti i biglietti o le fatture.",
  enterTheAmountInKilograms: "Inserisci l'importo in chilogrammi",
  pleaseScanAValidQRCode: "Scansiona un codice QR valido.",
  doYouWantToReceiveYourTicketInvoiceInYour:
    "Vuoi ricevere il tuo biglietto/fattura nel tuo",
  whatDoYouWantToPay: "Cosa vuoi pagare?",
  noProductsLeftToPay: "Nessun prodotto rimasto da pagare",
  totalSelected: "Totale selezionato :",
  error: "Errore!",
  discard: "Scartare",
  thereIsNoOrderForTheTable: "Non c'è ordine per il tavolo",
  tableOrder: "Ordine del tavolo",
  invitation: "INVITO",
  splitAccount: "dividere il conto",
  byProducts: "per prodotti",
  cookingMeat: "CUCINARE LA CARNE",
  chooseYourDrink: "SCEGLI IL TUO DRINK",
  chooseYourDishes: "Scegli i tuoi piatti",
  selectTheQRCodeOfTheTable: "Seleziona il QR code del tuo tavolo",
  oopsSelectYourTable: "Ops, seleziona il tuo tavolo",
  selectYourTable: "Seleziona il tuo tavolo",
  wellCooked: "Ben cotto",
  toThePoint: "Al punto",
  underCooked: "poco cotto",
  pleaseDecreaseTheQuantityOfProducts:
    "Si prega di ridurre la quantità di prodotti",
  divide: "Dividere",
  among: "Tra",
  amountToPay: "Somma da pagare",
  amount: "Quantità",
  allTheProducts: "Tutti i prodotti",
  pleaseEnterValidAmount:
    "Si prega di inserire un importo valido maggiore di € 0,50 o inferiore a"
};
